import { SelectHTMLAttributes, forwardRef } from 'react';
import { IconChevronDown } from '@tabler/icons-react';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  helper?: string;
  error?: string;
  options: { value: string; label: string }[];
  fullWidth?: boolean;
}

export default forwardRef<HTMLSelectElement, Props>(function Select(
  { label, helper, error, options, fullWidth = true, className = '', id, ...rest },
  ref,
) {
  const selectId = id || rest.name;
  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label htmlFor={selectId} className="block text-13 font-medium text-heading mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          ref={ref}
          id={selectId}
          className={[
            'w-full h-10 pl-3.5 pr-10 rounded-md border bg-surface text-13 text-heading appearance-none cursor-pointer',
            'outline-none transition-colors',
            error ? 'border-danger focus:border-danger' : 'border-border focus:border-primary',
            'disabled:bg-light disabled:cursor-not-allowed',
            className,
          ].join(' ')}
          {...rest}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <IconChevronDown
          size={16}
          className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
        />
      </div>
      {(helper || error) && (
        <p className={['text-11 mt-1', error ? 'text-danger' : 'text-gray-500'].join(' ')}>
          {error || helper}
        </p>
      )}
    </div>
  );
});
